<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="80px">
      <el-form-item label="类型">
        <el-select v-model="type" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="文件">
        <el-upload
          ref="uploadRef"
          class="upload-demo"
          action=""
          :auto-upload="false"
          :on-change="handleFileChange"
          :file-list="fileList"
          accept=".xls,.xlsx"
          :before-upload="beforeUpload"
        >
          <el-button type="primary" size="mini" icon="el-icon-plus">选择文件</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" @click="submitForm">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { proxyConfigImportrrr } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      type: 1,
      options: [
        {
          value: 1,
          label: '云手机'
        }, {
          value: 2,
          label: '由创'
        }

      ],
      fileList: [], // 存放选择的文件
      selectedFile: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    handleFileChange(file, fileList) {
      this.fileList = fileList.slice(-1)
      this.selectedFile = file.raw
    },

    beforeUpload(file) {
      const allowedExt = ['.xls', '.xlsx']
      const isExcel = allowedExt.some(ext => file.name.toLowerCase().endsWith(ext))

      if (!isExcel) {
        this.$message.error('只能上传 Excel 文件 (.xls/.xlsx)')
      }

      return isExcel // 返回 false 阻止文件加入 file-list
    },
    async submitForm() {
      if (!this.selectedFile) {
        this.$message.error('请先选择文件')
        return
      }
      const formData = new FormData()
      formData.append('type', this.type)
      formData.append('bind_file', this.selectedFile)
      try {
        await proxyConfigImportrrr(formData)
        // const res = await axios.post('/api/spWorkWechat/proxy/record/importBind', formData, {
        //   headers: { 'Content-Type': 'multipart/form-data' }
        // })
        this.$message.success('上传成功')
        this.$emit('chuandialogupdata')
      } catch (err) {
        console.error(err)
        this.$message.error('上传失败')
      }
    },
    importExc() {

    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
